import { STREAM_SAFETY_POLL_INTERVAL_MS } from './game-stream'

export const ACTIVE_POLL_INTERVAL_MS = 1500

export const PAUSED_POLL_INTERVAL_MS = 15_000

export const PAUSED_GAME_STATUS = 'paused'

export const TERMINAL_GAME_STATUSES = ['completed', 'error'] as const

export type TerminalGameStatus = (typeof TERMINAL_GAME_STATUSES)[number]

export function isTerminalGameStatus(
  status: string | null | undefined,
): status is TerminalGameStatus {
  return (
    status === 'completed'
    || status === 'error'
  )
}

export interface PlayPollingState {
  lastSuccessfulStatus?: string | null
  lastFetchFailed?: boolean
  nextInput?: unknown
  streaming?: boolean
}

export function resolvePlayPollInterval(
  state: PlayPollingState,
): number | false {
  if (isTerminalGameStatus(state.lastSuccessfulStatus))
    return false
  if (state.streaming)
    return STREAM_SAFETY_POLL_INTERVAL_MS
  if (
    state.lastSuccessfulStatus === PAUSED_GAME_STATUS
    && state.nextInput === null
  ) {
    return PAUSED_POLL_INTERVAL_MS
  }
  return ACTIVE_POLL_INTERVAL_MS
}

export function playRefetchInterval(
  query: { state?: { data?: unknown, fetchStatus?: string, status?: string } },
  streaming = false,
): number | false {
  const data = query?.state?.data as
    | { game?: { status?: string }, nextInput?: unknown }
    | undefined
  return resolvePlayPollInterval({
    lastFetchFailed: query?.state?.status === 'error',
    lastSuccessfulStatus: data?.game?.status,
    nextInput: data ? data.nextInput : undefined,
    streaming,
  })
}
